import type { AppRouter } from '@alison/api/router';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import type { TRPCClientErrorLike } from '@trpc/client';
import type { inferInput, inferOutput } from '@trpc/tanstack-react-query';
import { useTRPC } from '../../../../lib/trpc';

type TRPC = ReturnType<typeof useTRPC>;

type QueryResult<TData> = UseQueryResult<TData, TRPCClientErrorLike<AppRouter>>;

export type CompetitionElementsScope = inferInput<TRPC['competition']['elements']>;
export type CompetitionElementsData = inferOutput<TRPC['competition']['elements']>;
export type CompetitionElementRow = CompetitionElementsData['rows'][number];
export type ElementStatus = CompetitionElementRow['status'];

export function useCompetitionElements(
  scope: CompetitionElementsScope,
  enabled: boolean,
): QueryResult<CompetitionElementsData> {
  const trpc = useTRPC();
  return useQuery({ ...trpc.competition.elements.queryOptions(scope), enabled });
}

export function useCompetitionElementsMostUsed(
  scope: CompetitionElementsScope,
  enabled: boolean,
): QueryResult<CompetitionElementsData> {
  const trpc = useTRPC();
  return useQuery({ ...trpc.competition.elementsMostUsed.queryOptions(scope), enabled });
}
